import { render, staticRenderFns } from "./BundleManagement.vue?vue&type=template&id=29799b6c"
import script from "./BundleManagement.vue?vue&type=script&lang=js"
export * from "./BundleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports